// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"loader_wrapper__3lfjj","loader":"loader_loader__2sbTU","spin":"loader_spin__3WO-j","label":"loader_label__1Xa1w","focusable":"loader_focusable__3lbU0"};